// let timer;
import axios from "axios";

export default {
  
    async login(context, payload) {
    return context.dispatch('auth', {
      ...payload
    });
  },
  
  async auth(context, payload) {
    console.log(payload);
    const responseData = await axios({
        method: 'post',
        url: process.env.VUE_APP_API_ENDPOINT+'login',
        data: {
          username: payload.username,
          password: payload.password
        },
        mode: 'no-cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        }
    })

    if(responseData.request.status!=200 && responseData.request.statusText!='OK'){
        const error = new Error(
            responseData.message || 'Failed to authenticate. Check your login data.'
        );
        throw error;
    } 

    if(!responseData.data.success){
        const error = new Error(
            responseData.data.message
        );
        throw error;
    }

    // const expiresIn = +responseData.data.expiresIn * 1000;
    // const expiresIn = 3600*1000;
    // const expiresIn = 5*1000;
    // const expirationDate = new Date().getTime() + expiresIn;
    // console.log(responseData.data.user);
    localStorage.setItem('token', responseData.data.token);
    localStorage.setItem('userId', responseData.data.user.email);
    // localStorage.setItem('tokenExpiration', expirationDate);

    // timer = setTimeout(function() {
    //   context.dispatch('autoLogout');
    // }, expiresIn);

    context.commit('setUser', {
      token: responseData.data.token,
      userId: responseData.data.user.email
    });
  },

  tryLogin(context) {
    const token = localStorage.getItem('token');
    console.log("token: "+token);
    const userId = localStorage.getItem('userId');
    console.log("user id: "+userId);
    // const tokenExpiration = localStorage.getItem('tokenExpiration');

    // const expiresIn = +tokenExpiration - new Date().getTime();

    // if (expiresIn < 0) {
    //   return;
    // }

    // timer = setTimeout(function() {
    //   context.dispatch('autoLogout');
    // }, expiresIn);

    if (token && userId) {
      context.commit('setUser', {
        token: token,
        userId: userId
      });
    }
  },

  logout(context) {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    // localStorage.removeItem('tokenExpiration');

    // clearTimeout(timer);

    context.commit('setUser', {
      token: null,
      userId: null
    });
  },

  autoLogout(context) {
    context.dispatch('logout');
    context.commit('setAutoLogout');
  }

};
